module.exports = __webpack_public_path__ + "static/media/t-Tangent.2cacd5af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t-Tangent.png
// module id = 185
// module chunks = 0